import Vue from 'vue'

function yearDoesNotExist (state, year) {
  return state.events[year] === undefined
}

export default {
  SET_PREVIOUS_MONTH (state) {
    if (state.month <= 1) {
      state.month = 12
      state.year--
    } else {
      state.month--
    }
  },
  SET_NEXT_MONTH (state) {
    if (state.month >= 12) {
      state.month = 1
      state.year++
    } else {
      state.month++
    }
  },
  SET_TODAY (state) {
    const now = new Date()
    state.year = now.getFullYear()
    state.month = now.getMonth() + 1
  },
  SET_YEAR (state, year) {
    state.year = year
  },
  SET_MONTH (state, month) {
    state.month = month
  },
  SET_EVENTS (state, { month, year, events }) {
    events.forEach((e) => {
      e.category = 'time'
      e.title = e.name
      e.calendarId = e.calendar_id
    })
    if (yearDoesNotExist(state, year)) {
      Vue.set(state.events, year, [])
    }
    Vue.set(state.events[year], month, events)
  },
  SET_STATUS (state, { month, year, status }) {
    Vue.set(state.states, `${('0' + month).slice(-2)}.${year}`, status)
  },
  CHANGE_VIEW (state) {
    state.mobile = !state.mobile
  },
  SET_CALENDARS (state, calendars) {
    calendars.forEach((calendar) => {
      calendar.bgColor = calendar.color
      calendar.color = 'white'
    })
    state.calendars = calendars
  },
  SET_CALENDAR_STATUS (state, status) {
    state.calendarStatus = status
  }
}
